import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Fri Oct 19 2018
 * @author PKr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { jsonConversions, DummyWindowConverter, DummyWindowInfoDTOConverter } from '@logio/common-be-fe';
import { CRUTransportLayer } from '../CRUTransportLayer';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api/index';
import logger from '../../logger/index';
export var DummyWindowLayer =
/*#__PURE__*/
function (_CRUTransportLayer) {
  _inherits(DummyWindowLayer, _CRUTransportLayer);

  function DummyWindowLayer() {
    _classCallCheck(this, DummyWindowLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(DummyWindowLayer).call(this, CONSTANTS.API.ENDPOINTS.DUMMY_WINDOWS));
  }

  _createClass(DummyWindowLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
  }, {
    key: "findAllInfos",
    value: function findAllInfos(promotionId) {
      var _this = this;

      function buildUri(base) {
        return "".concat(base).concat(promotionId ? "?promotionId=".concat(promotionId) : '');
      }

      return api(buildUri(this.baseUri)).get({
        responseType: 'json'
      }).then(function (response) {
        return (response.data.result || []).map(function (item) {
          return _this.dummyWindowInfoDTOConverter.toObject(item, jsonConversions);
        });
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Deletes given theme
     */

  }, {
    key: "delete",
    value: function _delete(id) {
      return api("".concat(this.baseUri, "/").concat(id)).delete().then(function (response) {
        return response.data;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }]);

  return DummyWindowLayer;
}(CRUTransportLayer);

__decorate([Inject, __metadata("design:type", DummyWindowConverter)], DummyWindowLayer.prototype, "converter", void 0);

__decorate([Inject, __metadata("design:type", DummyWindowInfoDTOConverter)], DummyWindowLayer.prototype, "dummyWindowInfoDTOConverter", void 0);